import Main from "./components/Main";
import './assets/css/bootstrap.min.css';
import './assets/css/fontawesome.min.css';
import './assets/css/brands.min.css';
import './assets/css/regular.min.css';
import './assets/css/solid.min.css';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
